import { gql } from 'graphql-tag'

const getBriefings = (market: string) => {
  return gql`
    query getBriefings {
      allEvSales(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      automakerLeagueTables(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      batterySnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      batteryMineralsSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      inventoryTrackers(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      rawMaterialPrices(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      supplyChainCapitalTrackers(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      profitabilityHeatmaps(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      energyTransitionCapitals(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      energyIndicators(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      eu2025VehicleEmissions(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      geoEconomicAndPolicyBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      regionalSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      chinaBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      sustainabilityBriefings(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
      countryRiskSnapshots(
        first: 1
        where: {taxQuery: {taxArray: [{taxonomy: MARKETBRIEFINGCATEGORY, terms: ["all-markets", "${market}"], field: SLUG}]}}
      ) {
        nodes {
          title
          date
          slug
          viewerCanRead
          __typename
          briefings {
            publicationFrequency
            estimatedReadingTime
          }
        }
      }
    }
  `
}

export default getBriefings
